document.querySelectorAll('a[href="#"]').forEach(function (anchor) {
  anchor.addEventListener('click', function (e) {
    e.preventDefault();
  });
});

function scroll(element, parent) {
  var el = typeof element === 'string' ? document.querySelector(element) : element;
  if (!el) return;
  var container =
    parent === 'body' || parent === document.body
      ? null
      : typeof parent === 'string'
        ? document.querySelector(parent)
        : parent;
  if (container && container !== document.documentElement) {
    var elRect = el.getBoundingClientRect();
    var parentRect = container.getBoundingClientRect();
    var top = container.scrollTop + elRect.top - parentRect.top;
    container.scrollTo({ top: top, behavior: 'smooth' });
  } else {
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}
